import React, { useState, useRef, Suspense, lazy, useMemo } from "react";
import "../../share/components/dialog/answer.module.scss";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { getCountryFlag } from "../../../helperJs/getCountryFlag";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Checkbox from "@mui/material/Checkbox";
import { MAPDELETE_PROJECT_LOC } from "../../../services/constants";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import AreYousure from "../../share/card-layout/AreYousure";
import Spinner from "../../share/components/spinner";
import SettingsIcon from "@mui/icons-material/Settings";
import Tooltip from "@semcore/tooltip";
import { ZustandStore } from "../../../store/zustand-store";
import AddProjectStore from "../../../store/AddProjectStore";
import { useTranslation } from "react-i18next";

const AddProjectLocation = lazy(() => import("./AddProjectLocation"));

const ProjectSetting = () => {
  const projectDeletRef = useRef(null);
  const [anchorElUser, setAnchorElUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [DeleteAlert, setDeleteAlert] = useState(false);
  const [addProjLocation, setAddProjLocation] = useState(false);
  const [locationViewer, setLocationViewer] = useState([]);
  const [viewLoc, setViewLoc] = useState(false);
  const { t } = useTranslation();

  const { selected_project_id, USERCURRENTPROJECTLOCATION, map_project } =
    ZustandStore((state) => state);
  const { setMultipleFields } = AddProjectStore((state) => state);

  const competitorList = useMemo(() => {
    const project = map_project?.find(
      (item) => item.id === Number(selected_project_id)
    );
    if (!project) return [];
    return project?.Project?.[0]?.competitors || [];
  }, [map_project, selected_project_id]);

  const handleOpenUserMenu = () => {
    setLoading(false);
    setAnchorElUser((pre) => !pre);
  };

  const uniqueLocations = USERCURRENTPROJECTLOCATION?.reduce((acc, current) => {
    const x = acc.find((item) => item.location_code === current.location_code);
    if (!x) {
      acc.push(current);
    }
    return acc;
  }, []);

  const handleCloseUserMenu = () => {
    setAnchorElUser(false);
    setViewLoc(false);
  };

  const handleLocationSelected = (e) => {
    setLocationViewer((obj) => {
      const existingObj = obj.find((o) => o.location_code === e.location_code);
      if (existingObj) {
        const newArr = obj?.filter(
          (loc) => loc?.location_name !== e.location_name
        );
        return newArr;
      } else {
        return [
          ...obj,
          { location_code: e.location_code, location_name: e.location_name },
        ];
      }
    });
  };

  const keywordLocation = locationViewer?.map((loc) => {
    return loc?.location_name;
  });

  const handleOpenDeleteDialog = () => {
    setDeleteAlert(true);
    setAnchorElUser(false);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteAlert(false);
    setAnchorElUser(true);
    setLocationViewer([]);
  };

  const handleDeleteLocation = (res) => {
    if (!res) return handleCloseDeleteDialog(false);
    setLoading(true);
    const loc_code_Arr = locationViewer?.map((loc) => {
      return loc?.location_code;
    });
    const config = {
      id: Number(selected_project_id),
      location_code: JSON.stringify(loc_code_Arr),
    };
    handleCloseDeleteDialog();
    axios
      .delete(MAPDELETE_PROJECT_LOC(config))
      .then(() => {
        window.location.reload(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleAddProject = () => {
    setAddProjLocation(true);
    setAnchorElUser(false);
  };

  const handleAddCompetitors = () => {
    setMultipleFields({
      type: "Add-Competitors",
      step: 2,
      open: true,
      domainUrl: "",
      project_id: selected_project_id,
      project_name: "",
      language: null,
      location: [],
      complete_steps: [],
      competitors: competitorList,
      project_usage: { limits: [], loading: true, error: false },
    });
  };

  return (
    <>
      <Tooltip
        title={t(
          "rank_tracking.map_rank_tracker.project_setting_button.tooltip"
        )}
      >
        <button onClick={handleOpenUserMenu} ref={projectDeletRef}>
          <SettingsIcon fontSize="medium" className="me-1" />{" "}
          {t("rank_tracking.map_rank_tracker.project_setting_button.title")}
        </button>
      </Tooltip>

      <Menu
        id="basic-menu"
        anchorEl={projectDeletRef.current}
        open={anchorElUser}
        onClose={handleCloseUserMenu}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        className="delete-project-cont"
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              width: 250,
              // height: 300,
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
      >
        {!viewLoc
          ? [
              <MenuItem
                className="d-flex align-items-center justify-content-center"
                sx={{
                  "&:hover": {
                    background: "transparent",
                  },
                }}
                key={"Add/deleteLocation"}
              >
                <Button
                  variant="outlined"
                  onClick={() => setViewLoc((pre) => !pre)}
                  sx={{
                    borderColor: "gray",
                    color: "gray",
                    whiteSpace: "normal",
                  }}
                  className="w-100"
                >
                  {t(
                    "rank_tracking.map_rank_tracker.project_setting_button.menus.add_delete_location.title"
                  )}
                </Button>
              </MenuItem>,

              <MenuItem
                className="d-flex align-items-center justify-content-center"
                sx={{
                  "&:hover": {
                    background: "transparent",
                  },
                }}
                key={"add_competitors"}
                onClick={handleCloseUserMenu}
              >
                <Button
                  variant="outlined"
                  sx={{
                    borderColor: "gray",
                    color: "gray",
                    whiteSpace: "normal",
                  }}
                  onClick={() => handleAddCompetitors()}
                  className="w-100"
                >
                  {t(
                    "rank_tracking.map_rank_tracker.project_setting_button.menus.add_competitors.title"
                  )}
                </Button>
              </MenuItem>,
            ]
          : [
              <MenuItem
                className="d-flex align-items-center justify-content-center"
                sx={{
                  "&:hover": {
                    background: "transparent",
                  },
                }}
                key={"AddLocation"}
              >
                <Button
                  startIcon={<AddIcon />}
                  variant="outlined"
                  disabled={loading || locationViewer?.length > 0}
                  onClick={handleAddProject}
                  sx={{
                    borderColor: "gray",
                    color: "gray",
                    whiteSpace: "normal",
                  }}
                  className="w-100"
                >
                  {t(
                    "rank_tracking.rank_tracker.project_setting_button.menus.add_location.title"
                  )}
                </Button>
              </MenuItem>,

              loading ? (
                <MenuItem
                  className="d-flex align-items-center justify-content-center"
                  style={{ minHeight: "190px" }}
                  sx={{
                    "&:hover": {
                      background: "transparent",
                      whiteSpace: "normal",
                    },
                  }}
                  key={"Spinner"}
                >
                  <Spinner />
                </MenuItem>
              ) : (
                <MenuItem
                  className="loc-dele-pro-list "
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    height: "190px",
                    overflowY: "auto",
                  }}
                  key={"uniqueLocations"}
                  sx={{
                    "&:hover": {
                      background: "transparent",
                    },
                  }}
                >
                  {uniqueLocations?.map((item) => {
                    return (
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        key={item.location_name}
                        onClick={() => handleLocationSelected(item)}
                        className="w-100"
                        sx={{
                          whiteSpace: "break-spaces",
                          "&:hover": {
                            background: "rgba(0, 0, 0, 0.04)",
                          },
                        }}
                      >
                        <Checkbox
                          checked={keywordLocation?.includes(
                            item.location_name
                          )}
                          readOnly
                        />

                        {getCountryFlag(item.location_name) && (
                          <img
                            src={getCountryFlag(item.location_name)}
                            alt="coutry-flag"
                            className="me-2"
                          />
                        )}
                        {item.location_name}
                      </Typography>
                    );
                  })}
                </MenuItem>
              ),

              <MenuItem
                className="d-flex align-items-center justify-content-center h-auto"
                key={"DeleteLocation"}
                sx={{
                  "&:hover": {
                    background: "transparent",
                    whiteSpace: "normal",
                  },
                }}
              >
                <Button
                  startIcon={<DeleteIcon />}
                  disabled={locationViewer?.length === 0}
                  onClick={handleOpenDeleteDialog}
                  className="w-100"
                >
                  {t(
                    "rank_tracking.rank_tracker.project_setting_button.menus.delete_location.title"
                  )}
                </Button>
              </MenuItem>,
            ]}
      </Menu>
      {DeleteAlert && (
        <AreYousure
          callback={handleDeleteLocation}
          title={"You want to delete this location ?"}
        />
      )}

      {addProjLocation && (
        <Suspense fallback={null}>
          <AddProjectLocation
            {...{
              addProjLocation,
              project_id: Number(selected_project_id),
              setAddProjLocation,
            }}
          />
        </Suspense>
      )}
    </>
  );
};

export default ProjectSetting;
